<form
    class="shipping-info-form"
    style="width: 100%"
    [formGroup]="editform"
    (ngSubmit)="editform.valid && saveFn()"
    autocomplete="off"
>
    <div class="grid">
        <div class="col-12 md:col-4 v">
            <label class="control-label">
                <strong
                    >Weight
                    <span
                        style="color: red; font-size: 1.25rem"
                    ></span> </strong
            ></label>
            <p-inputNumber
                [style]="{ 'margin-top': '7px' }"
                formControlName="weight"
                mode="decimal"
                [format]="true"
                [useGrouping]="true"
                [allowEmpty]="false"
                [max]="100000"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                (onInput)="onInput($event, 'shippingWeight')"
                (onBlur)="onBlurSetDefault('shippingWeight', 'weight')"
            ></p-inputNumber>
        </div>
        <div class="col-12 md:col-4">
            <label class="control-label">
                <strong
                    >Weight Unit
                    <span
                        style="color: red; font-size: 1.25rem"
                    ></span> </strong
            ></label>
            <p-dropdown
                [style]="{
                    width: '100%',

                    'margin-top': '7px'
                }"
                class="p-dropdown-1"
                appendTo="body"
                [options]="_abd.WeightUOM"
                [(ngModel)]="_productService.selectedShippingWeight"
                optionLabel="title"
                [filter]="false"
                filterBy="title"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="_productService.isViewOnly"
            ></p-dropdown>
        </div>
        <div class="col-12 md:col-4">
            <label class="control-label">
                <strong>Dimensions</strong>
            </label>
            <p-dropdown
                [style]="{
                    width: '100%',
                    'margin-top': '7px'
                }"
                class="p-dropdown-1"
                appendTo="body"
                [options]="_abd.DimensionUOM"
                [(ngModel)]="_productService.selectedShippingDimension"
                optionLabel="title"
                [filter]="false"
                filterBy="title"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="_productService.isViewOnly"
            ></p-dropdown>
        </div>
    </div>
    <div class="grid">
        <div class="col-12 md:col-4 v">
            <label class="control-label">
                <strong
                    >Height
                    <span
                        style="color: red; font-size: 1.25rem"
                    ></span> </strong
            ></label>
            <p-inputNumber
                [style]="{ 'margin-top': '7px' }"
                formControlName="height"
                mode="decimal"
                [format]="true"
                [useGrouping]="true"
                [allowEmpty]="false"
                [max]="100000"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                (onInput)="onInput($event, 'shippingHeight')"
                (onBlur)="onBlurSetDefault('shippingHeight', 'height')"
            ></p-inputNumber>
        </div>
        <div class="col-12 md:col-4 v">
            <label class="control-label">
                <strong
                    >Width
                    <span
                        style="color: red; font-size: 1.25rem"
                    ></span> </strong
            ></label>
            <p-inputNumber
                [style]="{ 'margin-top': '7px' }"
                formControlName="width"
                mode="decimal"
                [format]="true"
                [useGrouping]="true"
                [allowEmpty]="false"
                [max]="100000"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                (onInput)="onInput($event, 'shippingWidth')"
                (onBlur)="onBlurSetDefault('shippingWidth', 'width')"
            ></p-inputNumber>
        </div>
        <div class="col-12 md:col-4 v">
            <label class="control-label">
                <strong
                    >Depth
                    <span
                        style="color: red; font-size: 1.25rem"
                    ></span> </strong
            ></label>
            <p-inputNumber
                [style]="{ 'margin-top': '7px' }"
                formControlName="length"
                mode="decimal"
                [format]="true"
                [useGrouping]="true"
                [allowEmpty]="false"
                [max]="100000"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                (onInput)="onInput($event, 'shippingLength')"
                (onBlur)="onBlurSetDefault('shippingLength', 'length')"
            ></p-inputNumber>
        </div>
    </div>
</form>
